export default "__VITE_ASSET__780963d5__"